import type { ReactNode } from "react";
import styles from "./DocumentPage.module.css";

interface DocumentPageProps {
  id: string;
  pageNumber?: number;
  tone?: "paper" | "ink" | "lime";
  className?: string;
  children: ReactNode;
}

interface DocumentPageNumberProps {
  children: ReactNode;
}

export function DocumentPageNumber({
  children,
}: DocumentPageNumberProps) {
  return (
    <span className={styles.pageNumber}>
      {children}
    </span>
  );
}

export function DocumentPage({
  id,
  pageNumber,
  tone = "paper",
  className = "",
  children,
}: DocumentPageProps) {
  return (
    <section
      id={id}
      className={`${styles.page} ${styles[tone]} portfolio-page ${className}`}
      data-page-number={pageNumber}
    >
      <div className={styles.content}>{children}</div>

      {pageNumber !== undefined && (
        <DocumentPageNumber>
          {String(pageNumber).padStart(2, "0")}
        </DocumentPageNumber>
      )}
    </section>
  );
}